import { CaseForm } from 'components/forms';

const PropertyCaseCreation = () => (
  <CaseForm />
);

export default PropertyCaseCreation;